var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPhysicalActivityIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_481_1206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9906 12.7316C18.7384 12.7316 18.532 12.5252 18.532 12.2673C18.532 12.0094 18.7384 11.803 18.9906 11.803H20.1141C19.8218 7.17715 16.1475 3.46845 11.5675 3.18757V4.29961C11.5675 4.55182 11.3611 4.76391 11.1089 4.76391C10.8567 4.76391 10.6503 4.55756 10.6503 4.29961V3.17611C5.9729 3.3538 2.18968 7.10836 1.89161 11.803H3.2272C3.47942 11.803 3.68577 12.0094 3.68577 12.2673C3.68577 12.5252 3.47942 12.7316 3.2272 12.7316H1.88015C2.04638 17.5523 5.88692 21.4387 10.6503 21.6222V20.235C10.6503 19.977 10.8567 19.7707 11.1089 19.7707C11.3611 19.7707 11.5675 19.977 11.5675 20.235V21.6107C16.2335 21.3241 19.9594 17.4778 20.1256 12.7316H18.9906ZM14.6972 8.21467L11.5961 12.7775C11.5961 12.7775 11.5503 12.8291 11.5274 12.852C11.3898 13.0067 11.1949 13.0985 10.9713 13.0985C10.5586 13.0985 10.2204 12.7545 10.2204 12.3361C10.2204 12.187 10.2663 12.0552 10.3351 11.9348C10.358 11.8832 10.3867 11.8374 10.4211 11.7973L13.9979 7.62999C14.1584 7.45229 14.4336 7.4351 14.617 7.58986C14.8004 7.74463 14.8348 8.01404 14.6972 8.20894V8.21467ZM19.2887 5.08491L20.0969 3.89836C20.3835 3.50284 20.2918 2.94682 19.902 2.66021L17.8614 1.16412C17.4716 0.877513 16.9213 0.963495 16.6404 1.35901L15.901 2.43666C14.4278 1.69148 12.7655 1.27303 11.0057 1.27303C9.0568 1.27303 7.22824 1.78893 5.64044 2.68314L4.96978 1.82905C4.67744 1.43926 4.12715 1.36475 3.7431 1.66282L1.73684 3.20477C1.35279 3.50284 1.27827 4.05886 1.57061 4.44864L2.39031 5.48616C0.894216 7.39497 0 9.79101 0 12.4049C0 18.5497 4.92392 23.5252 11 23.5252C17.0761 23.5252 22 18.544 22 12.4049C22 9.60185 20.9739 7.04531 19.283 5.09065L19.2887 5.08491ZM11 22.5565C5.46274 22.5565 0.957269 17.9995 0.957269 12.4049C0.957269 6.81029 5.46274 2.2475 11 2.2475C16.5373 2.2475 21.0427 6.80456 21.0427 12.3991C21.0427 17.9937 16.5373 22.5508 11 22.5508V22.5565Z",
    fill: "url(#paint0_linear_481_1206)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_481_1206",
    x1: 11,
    y1: 25.8468,
    x2: 11,
    y2: -1.32363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F88A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4291AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309EC0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_481_1206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhysicalActivityIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Physical_Activity_Icon.0990aef1.svg";
export { ForwardRef as ReactComponent };